import { cva } from 'class-variance-authority';

export const checkboxContainerStyles = cva(['flex', 'items-center', 'cursor-pointer', 'select-none'], {
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-50',
      false: '',
    },
  },
});
export const checkboxBoxStyles = cva('border rounded flex items-center justify-center duration-150', {
  variants: {
    disabled: {
      true: 'bg-grey-500 border-grey-500',
      false: '',
    },
    intent: {
      secondary: '',
      buttonDefault: '',
      default: 'border-blue-900 bg-white',
      transparent: '',
    },
    size: {
      small: 'w-4 h-4 min-w-4 min-h-4',
      xsmall: 'w-4.5 h-4.5 min-w-4.5 min-h-4.5',
      medium: 'w-5 h-5 min-w-5 min-h-5',
      large: 'w-6 h-6 min-w-6 min-h-6',
    },
    selected: {
      true: [],
      false: [],
    },
  },
  compoundVariants: [
    {
      intent: 'buttonDefault',
      disabled: false,
      selected: true,
      className: 'border-blue-300 bg-blue-300',
    },
    {
      intent: 'buttonDefault',
      disabled: true,
      selected: true,
      className: 'border-gray-500 bg-gray-500',
    },
    {
      intent: 'buttonDefault',
      disabled: false,
      selected: false,
      className: 'border-blue-300 bg-white',
    },
    {
      intent: 'buttonDefault',
      disabled: true,
      selected: false,
      className: 'border-gray-500 bg-gray-500',
    },
    {
      intent: 'buttonDefault',
      selected: false,
      className: 'border-neutral-400 bg-white',
    },
    {
      intent: 'secondary',
      selected: true,
      className: 'border-blue-300 bg-blue-300',
    },
    {
      intent: 'secondary',
      selected: false,
      className: 'border-neutral-400 bg-white',
    },
    {
      intent: 'secondary',
      size: 'medium',
      className: 'w-5 h-5 min-w-5 min-h-5',
    },
    {
      intent: 'secondary',
      size: 'large',
      className: 'w-6 h-6 min-w-6 min-h-6',
    },
    {
      intent: 'transparent',
      selected: true,
      className: 'border-blue-300 bg-blue-300',
    },
    {
      intent: 'transparent',
      selected: false,
      className: 'border-neutral-400',
    },
    {
      intent: 'transparent',
      disabled: true,
      selected: true,
      className: 'border-gray-500 bg-gray-500',
    },
    {
      intent: 'transparent',
      disabled: false,
      selected: false,
      className: 'border-neutral-400',
    },
  ],
  defaultVariants: {
    intent: 'default',
    size: 'medium',
    selected: false,
  },
});

export const checkboxIconStyles = cva([], {
  variants: {
    intent: {
      secondary: 'text-white',
      buttonDefault: 'text-white',
      default: 'text-blue-900',
      transparent: 'text-white',
    },
    size: {
      small: [],
      xsmall: 'max-md:w-3.5 max-md:h-3.5',
      medium: [],
      large: 'max-md:w-3.5 max-md:h-3.5',
    },
  },
  defaultVariants: {
    intent: 'buttonDefault',
    size: 'medium',
  },
  compoundVariants: [
    {
      intent: 'secondary',
      size: 'medium',
      className: 'w-3.5 h-3.5',
    },
    {
      intent: 'secondary',
      size: 'large',
      className: 'w-4 h-4',
    },
    {
      intent: 'secondary',
      size: 'small',
      className: 'w-3 h-3',
    },
    {
      intent: 'buttonDefault',
      size: 'medium',
      className: 'w-3.5 h-3.5',
    },
    {
      intent: 'buttonDefault',
      size: 'small',
      className: 'w-3 h-3',
    },
    {
      intent: 'default',
      size: 'medium',
      className: 'w-4 h-4',
    },
    {
      intent: 'default',
      size: 'small',
      className: 'w-3 h-3',
    },
  ],
});

export const checkboxIndeterminateStyles = cva([], {
  variants: {
    intent: {
      secondary: 'w-2.5 h-0.5 bg-white',
      buttonDefault: 'w-2 h-0.5 bg-white',
      default: 'w-2.5 h-0.5 bg-blue-900',
      transparent: ' bg-blue-900',
    },
  },
  defaultVariants: {
    intent: 'buttonDefault',
  },
});

export const visuallyHiddenStyles = cva(['opacity-0 w-0 h-0']);
